"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable: variable-name
var uom_1 = require("uom");
var uom_units_1 = require("uom-units");
var AmountConversion = require("../rp1485/amount-conversions");
var AirFlowState = require("../air-flow-state");
var AshraeHb2009 = require("../rp1485/ashrae-hb2009");
var rp1485_1 = require("../rp1485");
// Some formulas and constants
// http://en.wikipedia.org/wiki/Density_of_air
// http://en.wikipedia.org/wiki/International_Standard_Atmosphere
//
// Pressure conversion table: http://www.csgnetwork.com/pressconvtable.html
//
// const T0 = 288.15; // sea level standard temperature, K                (ASHRAE, U.S. STANDARD ATMOSPHERE)
// const g = 9.80665; // Earth-surface gravitational acceleration, m/s2   (ASHRAE, U.S. STANDARD ATMOSPHERE)
// const M = 0.0289644; // molar mass of dry air, kg/mol
// const R = 8.3144621; // molar (or universal) gas constant, J/(mol·K)
// const Rw = 461.495; // specific gas constant for water vapor, J/(kg·K)
// const L = 0.0065; // temperature lapse rate, K/m                      (ASHRAE, U.S. STANDARD ATMOSPHERE)
// const p0 = 101325.0; // sea level standard atmospheric pressure, Pa      (ASHRAE, U.S. STANDARD ATMOSPHERE)
//http://www.wolframalpha.com/input/?i=dry+air+the+specific+heat+capacity
var cpa_SI = 1.005; // specific heat capacity of air at temp -50 - 40 deg C, kJ/(kg°K)
function calculateAirSensiblePowerForAirFlowAirInAirOut(temperatureIn, humidity, pressureIn, temperatureOut, pressureOut, flow) {
    // P = Q * delta H.
    var hIn = AmountConversion.humidityRatioToSpecificEnthalpy(pressureIn, temperatureIn, humidity);
    var hOut = AmountConversion.humidityRatioToSpecificEnthalpy(pressureOut, temperatureOut, humidity);
    var airFlow = uom_1.Amount.valueAs(uom_units_1.Units.KilogramPerSecond, flow);
    var deltaH = uom_1.Amount.valueAs(uom_units_1.Units.KilojoulePerKilogram, uom_1.Amount.abs(uom_1.Amount.minus(hIn, hOut)));
    return uom_1.Amount.create(airFlow * deltaH, uom_units_1.Units.KiloWatt);
}
exports.calculateAirSensiblePowerForAirFlowAirInAirOut = calculateAirSensiblePowerForAirFlowAirInAirOut;
function calculateDensityOfMoistAirMixture(airState) {
    return AshraeHb2009.calculateDensityOfMoistAirMixture(airState.temperature, airState.pressure, airState.humidity);
}
exports.calculateDensityOfMoistAirMixture = calculateDensityOfMoistAirMixture;
function calculatePowerNeededToIncreaseAirTemperatureOfAir(flow, deltaTemperature) {
    return uom_1.Amount.create(uom_1.Amount.valueAs(uom_units_1.Units.KilogramPerSecond, flow) *
        cpa_SI *
        uom_1.Amount.valueAs(uom_units_1.Units.Celsius, deltaTemperature), uom_units_1.Units.KiloWatt);
}
exports.calculatePowerNeededToIncreaseAirTemperatureOfAir = calculatePowerNeededToIncreaseAirTemperatureOfAir;
function calculateAirTotalPowerForAirFlowAirInAirOut(temperatureIn, humidityIn, pressureIn, temperatureOut, humidityOut, pressureOut, flow) {
    var hIn = AmountConversion.humidityRatioToSpecificEnthalpy(pressureIn, temperatureIn, humidityIn);
    var hOut = AmountConversion.humidityRatioToSpecificEnthalpy(pressureOut, temperatureOut, humidityOut);
    var airFlow = uom_1.Amount.valueAs(uom_units_1.Units.KilogramPerSecond, flow);
    var deltaH = uom_1.Amount.valueAs(uom_units_1.Units.KilojoulePerKilogram, uom_1.Amount.abs(uom_1.Amount.minus(hIn, hOut)));
    return uom_1.Amount.create(airFlow * deltaH, uom_units_1.Units.KiloWatt);
}
exports.calculateAirTotalPowerForAirFlowAirInAirOut = calculateAirTotalPowerForAirFlowAirInAirOut;
function applyTotalPowerAsEnthalpyChangeOnFlowingAir(temperatureIn, humidityIn, pressureIn, pressureOut, flow, power) {
    var minTemperature = uom_1.Amount.create(-50, uom_units_1.Units.Celsius);
    var maxTemperature = uom_1.Amount.create(500, uom_units_1.Units.Celsius);
    var airIn = AirFlowState.create(temperatureIn, humidityIn, pressureIn, flow);
    var temperatureOut;
    var humidityOut;
    var delta = uom_1.Amount.create(0.01, uom_units_1.Units.Celsius);
    do {
        temperatureOut = uom_1.Amount.times(uom_1.Amount.plus(minTemperature, maxTemperature), 0.5);
        var airOut = AirFlowState.setTemperature(temperatureOut, AirFlowState.setPressure(pressureOut, airIn));
        humidityOut = airOut.humidity;
        var currentPower = calculateAirTotalPowerForAirFlowAirInAirOut(temperatureIn, humidityIn, pressureIn, temperatureOut, humidityOut, pressureOut, flow);
        var adjustedPower = uom_1.Amount.lessThan(temperatureOut, temperatureIn)
            ? uom_1.Amount.neg(currentPower)
            : currentPower;
        if (uom_1.Amount.lessThan(adjustedPower, power)) {
            minTemperature = temperatureOut;
        }
        else {
            maxTemperature = temperatureOut;
        }
    } while (uom_1.Amount.greaterThan(uom_1.Amount.minus(maxTemperature, minTemperature), delta));
    return {
        temperature: temperatureOut,
        humidity: humidityOut,
    };
}
exports.applyTotalPowerAsEnthalpyChangeOnFlowingAir = applyTotalPowerAsEnthalpyChangeOnFlowingAir;
function calculateAdiabaticMixingOfTwoAirstreams(air1, air2) {
    var totalFlow = uom_1.Amount.plus(air1.flow, air2.flow);
    if (uom_1.Amount.lessThan(totalFlow, uom_1.Amount.create(0.0001, uom_units_1.Units.StandardCubicMeterPerHour))) {
        return { airOut: air1, dehumidification: false };
    }
    var stream2RelativeFlow = uom_1.Amount.valueAs(uom_units_1.Units.KilogramPerSecond, air2.flow) /
        uom_1.Amount.valueAs(uom_units_1.Units.KilogramPerSecond, totalFlow);
    var temperatureOut = uom_1.Amount.plus(air1.temperature, uom_1.Amount.times(uom_1.Amount.minus(air2.temperature, air1.temperature), stream2RelativeFlow));
    var pressureOut = uom_1.Amount.min(air1.pressure, air2.pressure);
    var humidity = uom_1.Amount.plus(air1.humidity, uom_1.Amount.times(uom_1.Amount.minus(air2.humidity, air1.humidity), stream2RelativeFlow));
    var dewPoint = rp1485_1.AmountConversions.humidityRatioToDewPointTemperature(pressureOut, humidity);
    if (uom_1.Amount.lessThan(temperatureOut, uom_1.Amount.create(uom_1.Amount.valueAs(uom_units_1.Units.CelsiusDewPoint, dewPoint), uom_units_1.Units.Celsius))) {
        var stream1Enthalpy = AirFlowState.specificEnthalpy(air1);
        var stream2Enthalpy = AirFlowState.specificEnthalpy(air2);
        var enthalpy = uom_1.Amount.plus(stream1Enthalpy, uom_1.Amount.times(uom_1.Amount.minus(stream2Enthalpy, stream1Enthalpy), stream2RelativeFlow));
        var result = rp1485_1.AmountConversions.findSaturationLineEnthalpyLineIntersection(pressureOut, enthalpy);
        return {
            airOut: AirFlowState.create(result.t, result.x, pressureOut, totalFlow),
            dehumidification: true,
        };
    }
    return {
        airOut: AirFlowState.create(temperatureOut, humidity, pressureOut, totalFlow),
        dehumidification: false,
    };
}
exports.calculateAdiabaticMixingOfTwoAirstreams = calculateAdiabaticMixingOfTwoAirstreams;
